import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {MagicTriangleComponent} from 'app/tool-layer/tools/magic-triangle/magic-triangle.component';
import {ComponentModule} from 'app/component/component.module';

@NgModule({
    imports: [CommonModule, ComponentModule],
    declarations: [MagicTriangleComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(MagicTriangleComponent),
            multi: true,
        },
    ],
})
export class MagicTriangleModule {}
